module.exports = __webpack_public_path__ + "mz.000f27295afbecaa7242.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/mz.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/mz.svg
// module chunks = styles